import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import AopsCommonModalLayout from '../../../../components/apos/modal/AopsCommonModalLayout'
import '../orgChart.scss'
import CertificateRecipientInfo from '../ui/CertificateRecipientInfo'

// 전자문서 형태 선택 모달
const CertificateIssueModal = ({ open, onClose, personalInfo, onRequest }) => {
  const [selectedDocumentType, setSelectedDocumentType] = useState('근로계약서')

  const documentTypes = ['근로계약서', '연봉계약서', '재직증명서']

  const handleRequest = () => {
    onRequest?.(selectedDocumentType)
    onClose()
  }

  useEffect(() => {
    if (open) {
      setSelectedDocumentType('근로계약서')
    }
  }, [open])

  return (
    <AopsCommonModalLayout open={open} onClose={onClose} title="전자문서 발급">
      <div className="form-container">
        <div className="form-wrapper">
          {/* 발급자 정보 */}
          <CertificateRecipientInfo
            description={dayjs().format('YY년 MM월 DD일')}
            description2={
              <>
                발급자{' '}
                <span className="certificate-issue-name">
                  {personalInfo?.name}
                </span>
              </>
            }
          />

          {/* 전자문서 형태 */}
          <div className="certificate-document-type-container">
            <h3 className="certificate-document-type-title">전자문서 형태</h3>
            <div className="status-button-group">
              {documentTypes.map((type) => (
                <button
                  key={type}
                  type="button"
                  className={`status-tag ${
                    selectedDocumentType === type ? 'active' : ''
                  }`}
                  onClick={() => setSelectedDocumentType(type)}
                >
                  {type}
                </button>
              ))}
            </div>
          </div>

          {/* 하단 버튼 */}
          <div className="popup-footer">
            <button className="btn-cancel" onClick={onClose}>
              취소
            </button>
            <button className="btn-submit" onClick={handleRequest}>
              발급하기
            </button>
          </div>
        </div>
      </div>
    </AopsCommonModalLayout>
  )
}

export default CertificateIssueModal
